export default function Preloader(handle, { }) {
    function shuffle(array) {
        // Fisher-Yates shuffle algorithm
        let currentIndex = array.length, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }

        return array;
    }


    const grid = document.getElementById("preloader");
    const squares = Array.from(grid.getElementsByClassName("square"));

    shuffle(squares);

    function processWithDelay(squares, index, delay) {
        if (index >= squares.length) {
            grid.style.display = 'none';
        } else {
            // Do something with the current square
            squares[index].classList.add('reveal');

            // Schedule processing of the next square with delay
            setTimeout(() => processWithDelay(squares, index + 1, delay), delay);
        }
    }

    // Start processing the first square with a delay
    processWithDelay(squares, 0, 20);
}